
import { loadWidget } from '../utils/load-widget';

loadWidget('login-modal', {
    data: function() {
        return {
            ViewModel: {
                ModalActive: false,
                closeModalCallback: null,
            },
            ParentViewModel: null,
        };
    },
    methods: {
        closeModal: function () {
            this.ViewModel.ModalActive = false;
            this.ViewModel.closeModalCallback();
        },
        redirectToLogin: function () {
            window.location.href = `${window.AppConfig.bo_url}/account/login?returnurl=${encodeURIComponent(window.location.href)}`;
        }
    },
    beforeMount() {
        this.$root.$on('openLoginModal', (viewModel, closeModalCallback) => {
            this.ParentViewModel = viewModel;
            this.ViewModel.ModalActive = true;
            this.ViewModel.closeModalCallback = closeModalCallback;
        });
    }
});